// extracted by mini-css-extract-plugin
module.exports = {"date":"Maintenance_date__2l8SI"};